import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import Logo from "../Assets/rectangleLogo.png";
import Paper from "@mui/material/Paper";
import { Link } from "react-router-dom";

const pages = [
  {
    name: "Services",
    route: "/services",
  },
  {
    name: "Schedule",
    route: "/schedule",
  },
];

const ResponsiveAppBar = () => {
  // const { loggedIn } = useAppContext();
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  // const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  return (
    <>
      {
        <AppBar position="static" style={{ backgroundColor: "black" }}>
          <Container maxWidth="xl">
            <Toolbar disableGutters style={{ alignItems: "center" }}>
              {" "}
              {/* Ensure vertical alignment */}
              <Typography
                variant="h6"
                noWrap
                component="a"
                href="/"
                sx={{
                  mr: 2,
                  display: { xs: "none", md: "flex" },
                  fontFamily: "monospace",
                  fontWeight: 700,
                  letterSpacing: ".3rem",
                  color: "inherit",
                  textDecoration: "none",
                  alignItems: "center", // Align text vertically
                }}
              >
                Garage
                <span
                  style={{
                    backgroundColor: "yellow",
                    color: "black",
                    borderRadius: "5px",
                  }}
                >
                  GYM
                </span>
              </Typography>
              <Box
                sx={{
                  flexGrow: 1,
                  display: { xs: "flex", md: "none" },
                  justifyContent: "center", // Center links if needed
                  alignItems: "center", // Align links vertically
                  backgroundColor: "black",
                }}
              >
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorElNav}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  open={Boolean(anchorElNav)}
                  onClose={handleCloseNavMenu}
                  sx={{
                    display: { xs: "block", md: "none" },
                  }}
                >
                  {pages.map((page, idx) => (
                    <MenuItem key={idx} onClick={handleCloseNavMenu}>
                      <Button
                        key={idx}
                        href={page.route}
                        onClick={handleCloseNavMenu}
                        sx={{ color: "black" }}
                      >
                        {page.name}
                      </Button>
                    </MenuItem>
                  ))}
                </Menu>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column", // This ensures vertical stacking
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%", // Ensure the container takes full width
                  }}
                >
                  <img
                    src={Logo} // Replace with the path to your logo
                    alt="The Garage Gym"
                    style={{
                      maxWidth: "100%", // Ensure the image is responsive
                      height: "auto", // Maintain aspect ratio
                      display: "block", // Use block to apply auto margins.
                      marginTop: "0px", //
                    }}
                  />
                </Box>
                <Paper
                  elevation={4} // Add some shadow for depth
                  sx={{
                    mt: 4, // Margin top for spacing from the logo
                    p: 2, // Padding inside the Paper
                    backgroundColor: "black", // Use theme's secondary color
                    color: "magenta", // Text color
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    width: "90%", // Responsive width
                    border: "1px solid magenta",
                  }}
                >
                  <Typography
                    variant="h5"
                    component="h2"
                    sx={{ fontWeight: "bold", mb: 2 }} // Bold font weight and margin bottom for spacing
                  >
                    Special Offer!
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{ mb: 2 }} // Margin bottom for spacing between text
                  >
                    25% off on all personal training packages for 1st-time
                    members.
                  </Typography>
                  <Link to="/schedule-now" style={{ textDecoration: "none" }}>
                    <Button
                      variant="outlined" // Changed to "outlined" to apply border
                      sx={{
                        fontWeight: "bold", // Bold font weight for the button text
                        backgroundColor: "black", // Button background color
                        color: "magenta", // Button text color
                        borderColor: "magenta", // Border color
                        "&:hover": {
                          backgroundColor: "magenta", // Magenta background on hover
                          color: "black", // Black text color on hover
                          borderColor: "darkmagenta", // Darker magenta border on hover for a nice effect
                        },
                      }}
                    >
                      Schedule Now
                    </Button>
                  </Link>
                </Paper>
              </Box>
              <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
                {pages.map((page, idx) => (
                  <Button
                    key={idx}
                    href={page.route}
                    onClick={handleCloseNavMenu}
                    sx={{ my: 2, color: "white", display: "block" }}
                  >
                    {page.name}
                  </Button>
                ))}
              </Box>
            </Toolbar>
          </Container>
        </AppBar>
      }
    </>
  );
};
export default ResponsiveAppBar;
